import { Button } from "antd";
import { ButtonProps } from "antd/lib/button";
import * as React from "react";
import { useEffect, useState, FC } from "react";

export interface CooldownButtonProps extends ButtonProps {
    onClick: () => void;
    cooldown: number;
}

export const CooldownButton: FC<CooldownButtonProps> = ({ cooldown, onClick, children, ...buttonProps }) => {
    const [remaining, setRemaining] = useState(0);

    useEffect(() => {
        if (remaining <= 0) {
            return undefined;
        }

        const interval = setInterval(() => {
            setRemaining((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [remaining]);

    const handleClick = () => {
        if (remaining > 0) {
            return undefined;
        }

        onClick();
        setRemaining(cooldown);
    };

    return (
        <Button
            disabled={remaining > 0}
            onClick={handleClick}
            {...buttonProps}
        >
            {children}
            {remaining > 0 && `(${remaining}s)`}
        </Button>
    );
};
